import { Navigate, Outlet, useParams } from 'react-router-dom'

export default function AuthGuard() {
  const { slug } = useParams()
  const token = localStorage.getItem('token')

  if (!token) {
    return <Navigate to={`/${slug}/login`} replace />
  }

  return <Outlet />
}
